import type { MenuItem } from '@/types';

/**
 * Web docs menu
 */
export const webDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/web' },
  {
    label: 'Web SDK 2.0',
    path: '/sdk_ref/web/next-gen-overview',
    openNested: true,
    submenu: [
      { label: 'Web SDK 2.0 Overview', path: '/sdk_ref/web/next-gen-overview' },
      { label: 'Channel', path: '/sdk_ref/web/next-gen-channel' },
      { label: 'Logging & Error Handling', path: '/sdk_ref/web/websdk-2-logging-and-error-handling' },
    ],
  },
  {
    label: 'Web SDK 1.0',
    path: '/sdk_ref/web/overview',
    openNested: true,
    submenu: [
      { label: 'Web SDK 1.0 Overview', path: '/sdk_ref/web/overview' },
      {
        label: 'Express API',
        path: '/sdk_ref/web/express',
        openNested: true,
        submenu: [
          { label: 'Channel', path: '/sdk_ref/web/express-channel' },
          { label: 'Room', path: '/sdk_ref/web/express-room' },
          { label: 'PCast™', path: '/sdk_ref/web/express-pcast' },
        ],
      },
      {
        label: 'Low-Level API',
        path: '/sdk_ref/web/low-level',
        openNested: true,
        submenu: [
          { label: 'Room', path: '/sdk_ref/web/room' },
          { label: 'Chat', path: '/sdk_ref/web/chat' },
          { label: 'PCast™', path: '/sdk_ref/web/pcast' },
        ],
      },
    ],
  },
 
  { label: 'Browser Support', path: '/sdk_ref/web/browser-support' },
  { label: 'Embedding a Channel', path: '/sdk_ref/web/embedding-a-channel' },
  { label: 'Web Examples', path: '/sdk_ref/web/examples' },
  { label: 'Release Notes', path: '/sdk_ref/web/release-notes' },
];
